import { render, staticRenderFns } from "./RunoutReportTable.vue?vue&type=template&id=2a2149d4&scoped=true"
import script from "./RunoutReportTable.vue?vue&type=script&lang=js"
export * from "./RunoutReportTable.vue?vue&type=script&lang=js"
import style0 from "./RunoutReportTable.vue?vue&type=style&index=0&id=2a2149d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2149d4",
  null
  
)

export default component.exports